import React from 'react';
import {NavBar, List} from 'antd-mobile';
import {ArrowLeftOutlined, ExclamationCircleOutlined, UserOutlined} from '@ant-design/icons';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {useQuery} from '@apollo/client';
import {DspPath} from '../../../../enums/DeliveryNavigatePathEnum';
import {getNavBarContainerStyle} from '../../../../utils/deviceUtils';
import useDspWarehouseStore from '../../store/dspWarehouseStore';
import {
    GET_DSP_HOME_PENDING_SUMMARY,
    GetDspHomePendingSummaryResponse,
    GetDspHomePendingSummaryVariables,
} from '../graphql/queries/getDspHomePendingSummary';

const IssueParcelWorkbenchPage: React.FC = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();

    const selectedWarehouseId = useDspWarehouseStore((state) => state.selectedWarehouseId);
    const warehouseIdNumber = selectedWarehouseId ? Number(selectedWarehouseId) : null;

    const {data: summaryData} = useQuery<
        GetDspHomePendingSummaryResponse,
        GetDspHomePendingSummaryVariables
    >(GET_DSP_HOME_PENDING_SUMMARY, {
        variables: {
            warehouseId: warehouseIdNumber ?? 0,
        },
        skip: warehouseIdNumber == null,
        fetchPolicy: 'no-cache',
    });
    const complaintCount = summaryData?.getDspHomePendingSummary?.pendingIssueParcelCount ?? 0;

    return (
        <div className="bg-gray-50 min-h-screen">
            <div {...getNavBarContainerStyle()} className="fixed top-0 left-0 right-0 z-20 bg-white shadow-sm">
                <NavBar onBack={() => navigate(DspPath.DELIVERY_DSP_HOME)} backIcon={<ArrowLeftOutlined />}>
                    {t('pages.dsp.home.issueParcelWorkbench.title', '问题件工作台')}
                </NavBar>
            </div>

            <div className="pt-16">
                <List>
                    <List.Item
                        prefix={<ExclamationCircleOutlined style={{fontSize: 24, color: '#F59E0B'}} />}
                        onClick={() => navigate(DspPath.DELIVERY_DSP_COMPLAINT_LIST)}
                        description={t('pages.dsp.home.issueParcelWorkbench.complaintDescription', '客户投诉处理与申诉')}
                        extra={<span className="text-base font-semibold text-gray-800">{complaintCount}</span>}
                    >
                        {t('pages.dsp.home.issueParcelWorkbench.complaint', '客诉申诉')}
                    </List.Item>
                    <List.Item
                        prefix={<UserOutlined style={{fontSize: 24, color: '#8B5CF6'}} />}
                        onClick={() => navigate(DspPath.DELIVERY_DSP_DRIVER_VIOLATION_REVIEW, {
                            state: {from: DspPath.DELIVERY_DSP_ISSUE_PARCEL_WORKBENCH},
                        })}
                        description={t('pages.dsp.home.issueParcelWorkbench.driverViolationDescription', 'POD 人工审核异常处理')}
                    >
                        {t('pages.dsp.home.issueParcelWorkbench.driverViolation', '司机异常处理')}
                    </List.Item>
                </List>
            </div>
        </div>
    );
};

export default IssueParcelWorkbenchPage;
